/** Register the app-shell Service Worker (production / preview builds). */
export async function registerPlayerServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return;

  try {
    await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  } catch (error) {
    console.warn(
      '[ghostscreen] Service Worker registration failed',
      error instanceof Error ? error.message : error,
    );
  }
}
